<!--  -->
<template>
<div class="container">
    <!-- <div :class="['bg_music',{'active':isPlay}]" @click="playAudio">
        <img v-if="isPlay" src="@/assets/images/volume_on.png" alt="">
        <img v-else src="@/assets/images/volume_off.png" alt="">
    </div> -->
    
    <div class="page page1">
        <!-- <img class="img1 show0" src="@/assets/images/1.png" alt="">
        <img class="img2 show5" src="@/assets/images/2.png" alt=""> -->
        <!-- <img class="img1" src="@/assets/img/logo.png" alt="">
        <img class="font1 show5" src="@/assets/img/stit.png" alt="">
        <img class="font2 show6" src="@/assets/img/tit2.png" alt="">
       
        <img class="img4 show7" src="@/assets/img/seal.png" alt="">

        <div class="fonts fonts1">
            <img class="tit1 show1" src="@/assets/img/font1.png" alt="">
            <img class="show2" src="@/assets/img/font2.png" alt="">
        </div>
         <div class="fonts fonts2">
            <img class="show3" src="@/assets/img/font3.png" alt="">
            <img class="show4" src="@/assets/img/font4.png" alt="">
        </div> -->
    </div>
    <div class="page page2">
        <img class="mountain show0" src="@/assets/img/mont1.png" alt="">
        <div class="brief">
            <img class="brief-tit show8" src="@/assets/img/brief-tit.png" alt="">
            <div class="content show9">
                <p>“拓者，摹也。”拓片，是从原碑或圹誌等实物上直接摹拓下来的，它承载了原碑或圹誌等实物的主要信息，是古代比较科学的文献记录、保存手段，是古代文献的重要载体之一。它传承的不仅是文字史料，更将我国书法艺术的精髓代代相传。斧凿之间，捶拓之中，笔墨的神韵，前贤的幽思，中华之文脉在这深沉的碑刻墨拓艺术中传承至今。</p>
                <p>欧阳询、颜真卿、柳公权、赵孟頫，是四位古代著名楷书书法家，世称“楷书四大家”。新乡市博物馆馆藏历代名碑拓片资源丰富，本次展览将呈现数十件新乡市博物馆馆藏的欧阳询、颜真卿、柳公权、赵孟頫四家的书法碑刻拓片，他们的拓片是学习楷书的范本。这些拓片拉进了与古代书家的距离，使广大观众更好的体味中华文化的源远与博大。</p>
            </div>
        </div>
        <div class="persons">
            <img class="icon1" src="@/assets/img/icon1.png" alt="">
            <img class="line" src="@/assets/img/line.png" alt="">
        <div class="person person1" @click="$router.push('/author?m=1')">
            <img class="man" src="@/assets/images/8.png" alt="">
            <div class="name">欧阳询</div>
        </div>
         <div class="person person2" @click="$router.push('/author?m=2')">
            <img class="man" src="@/assets/images/9.png" alt="">
            <div class="name">颜真卿</div>
        </div>
         <div class="person person3" @click="$router.push('/author?m=3')">
            <img class="man" src="@/assets/images/11.png" alt="">
            <div class="name">柳公权</div>
        </div>
         <div class="person person4" @click="$router.push('/author?m=4')">
            <img class="man" src="@/assets/images/10.png" alt="">
            <div class="name">赵孟頫</div>
        </div>
        </div>
        
    </div>
    <div class="page page3">
        <div class="mountains">
            <img class="mountain2 show10" src="@/assets/img/mont2.png" alt="">
        </div>
        <div class="endcontent show7" :style="`background-image:url(${require('@/assets/img/bg_end.png')})`">
            <img src="@/assets/img/end-tit.png" alt="">
            <div class="content">
                <p>中国书法源远流长，书体众多，流派纷呈，楷书“四大家”只是这历史长河中四朵耀眼的浪花，永远萦绕在人们的心间。看过这个展览，你的心灵是否受到震撼，你会否为古人的艺术成就感到自豪，从而激发自己的工作热情和艺术灵感，为实现中国梦而贡献自己的一份力量。</p>
            </div>
        </div>
        <img class="icon2" src="@/assets/img/icon2.png" alt="">
    </div>
    
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import scrollReveal from 'scrollreveal'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
     play:true,
    isPlay:false,
    bgsrc:require('@/assets/bg.mp3'),
    scrollReveal:scrollReveal(),
    
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    playAudio() {
        
        if(this.isPlay){
            this.bgmusic.pause();
            this.isPlay = false;
        }else {
            this.bgmusic.play();
            this.isPlay = true;
        }
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    // this.$nextTick(()=>{   
    //   document.getElementById('bgvideo').play();
    // })
    // document.addEventListener('click',function(){
    //     document.getElementById('bgvideo').play();
    // })
    // document.getElementById('bgvideo').addEventListener('ended', () => { //该视频播放是否已结束
    //     this.play = false;       
    //   }, false)
   

    for(var index =0;index<4;index++) {
        this.scrollReveal.reveal('.show'+( index + 1),{
        origin:'top',
        distance:'1rem',
        duration:2000,
        opacity:0,
        delay:1000 + index*500,
        reset:true    
    })
    
    }
    this.scrollReveal.reveal('.show0',{
        origin:'right',
        distance:'2rem',
        duration:2000,
        opacity:0,
        delay:1000,
        reset:true    
    })
    this.scrollReveal.reveal('.show5',{
        origin:'left',
        distance:'2rem',
        duration:2000,
        opacity:0,
        delay:500,
        reset:true    
    })
    this.scrollReveal.reveal('.show6',{
       
        duration:2000,
        opacity:0,
        delay:500,
        reset:true    
    })
    this.scrollReveal.reveal('.show7',{
        origin:"center",
        duration:2000,
        opacity:0,
        scale:0.5,
        delay:2500,
        reset:true    
    })
    this.scrollReveal.reveal('.person1',{
        origin:'left',
        distance:'1rem',
        duration:2000,
        opacity:0,
        delay:500,
        reset:false    
    })
    this.scrollReveal.reveal('.person2',{
        origin:'right',
        distance:'1rem',
        duration:2000,
        opacity:0,
        delay:800,
        reset:false   
    })
    this.scrollReveal.reveal('.person3',{
        origin:'left',
        distance:'1rem',
        duration:2000,
        opacity:0,
        delay:1300,
        reset:false    
    })
    this.scrollReveal.reveal('.person4',{
        origin:'right',
        distance:'1rem',
        duration:2000,
        opacity:0,
        delay:1500,
        reset:false    
    })
     this.scrollReveal.reveal('.show8',{
        duration:2000,
        opacity:0,
        delay:1000,
        reset:true    
    })
     this.scrollReveal.reveal('.show9',{
        duration:2000,
        opacity:0,
        scale:0,
        origin:"center",
        delay:1200,
        reset:true    
    })
    this.scrollReveal.reveal('.show10',{
        origin:'left',
        distance:'2rem',
        duration:2000,
        opacity:0,
        delay:500,
        reset:true   
    })
    
   
        
       
    
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {
}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped>
   .container {
        width:100%;
        height:100%;
        background:url(../../assets/img/bg1.jpg)center top no-repeat,url(../../assets/img/bg2.jpg)center 192.95vw no-repeat,url(../../assets/img/bg3.jpg)center 386.267vw no-repeat,url(../../assets/img/bg4.jpg)center 579.2vw no-repeat;
        background-size:100% auto;
        /* background-attachment: fixed; */
        overflow:hidden;
       
    }
    .container.showvideo {
        height:193vw;
    }
    .bg_video {
        position:absolute;
        width:100%;
        height:193vw;
        top:0;
        z-index:1;
        background:#000;
    }
    .bg_video video {
        max-width:100%;
        max-height:100%;
    }
    .bg_music {
        position:fixed;
        width:10vw;
        right:2vw;
        top:2vw;
        height: 10vw;
        /* border-radius: 50%;
        box-shadow: 0 0 10px 0px #606060; */
        z-index:9999;
    }
    .bg_music.active {
        animation:AutoRotate 2s linear infinite;
    }
    @keyframes AutoRotate {
        0% {
            transform:rotate(0deg)
        }
        100% {
            transform:rotate(360deg)
        }
    }
    .page {
        position:relative;
        /* height:100vh; */
    }
    .page1 {
        position:relative;
        height:100vh;
    }
    .img1 {
        position:absolute;
        left:4vw;
        top:-12vw;
        width:30vw;
    }
    .img2 {
        position:absolute;
        left:0;
        bottom:0;
        width:57vw;
        height:130vw;
    }
    .img3 {
        position:absolute;
        top:34vw;
        right:5vw;
        width:47.3vw;
    }
    .img4 {
        position:absolute;
        top:52vw;
        right:10vw;
        width:9vw;
    }
    .fonts {
        width:32.8vw;
    }
    .fonts img {
        width:32.4vw;
        margin-bottom:-4vw;
        opacity:1;
    }
    .fonts1 {
        margin-left:50vw;
        margin-top:22vw;
    }
    .fonts1 .tit1 {
        margin-left:12vw;
    }
     .fonts2 {
        margin-left:63vw;
    }
    .font1 {
        position:absolute;
        right: 37vw;
        top: 63vw;
        width:19.3vw;
    }
    .font2 {
        position:absolute;
        left:2vw;
        top:4vw;
        width:12.67vw;
    }
    
    .mountain {
        position:absolute;
        top:-16vh;
        right:0;
        width:53.867vw;
        height:85.467vw;
    }
    .brief {
        position:relative;

    }
    .brief-tit {
        display:block;
        width:46.4vw;
        margin:0 auto;
    }
    .brief .content {
        font-family: "simkai";
        color:#0e0906;
        font-size:4vw;
        width:80%;
        margin:5vw auto;
    }
    .brief .content p {
        text-indent:2em;
        line-height:2;
        text-align: justify;
    }
    .persons {
        position:relative;
        margin-top:53vw;
    }
    .persons .line {
        position:absolute;
        display:block;
        width:86.67vw;
        left:4vw;
       
    }
    .icon1 {
        position:absolute;
        width:37.73vw;
        top:-45vw;
        left:8vw;
    }
    .person {
        position:relative;
    }
     @keyframes zooms{
        0% {
            transform:scale(0.95)
        }
        50% {
            transform:scale(1)
        }
        100% {
            transform:scale(0.95)
        }
    }
    .person .name {
        position:absolute;
        top:-5vw;
        right:0;
        animation:zooms 2s linear infinite ;
        width:9.06vw;
        height:28.13vw;
        background:url(../../assets/img/bg_name.png)center top/100% no-repeat;
        display:flex;
        flex-direction: column;
        justify-content: center;
        font-size:4.8vw;
        text-align:center;
        padding-top:3vw;
        font-family: "simkai";
        color:#0e0906;
    }
   
    .person1 {
        margin-left:16.3vw;
        width:30.67vw;
    }
    .person2 {
         width:36.26vw;
        margin-left:57vw;
        top:-17vw;
    }
    .person3 {
         width:31.6vw;
        margin-left:6vw;
        top:-10vh;
    }
    .person4 {
         width:25.8vw;
        margin-left:40vw;
        top:-12vh;
    }
    .person1 .man {
        width:30.67vw;
    }
    .person1 .name {
        right: 23vw;
        top: -16vw;
    }
     .person2 .man {
        width:36.26vw;
    }
    .person2 .name {
        top:-12vw;
    }
     .person3 .man {
        width:31.6vw;
    }
    .person3 .name {
        top:-20vw;
    }
     .person4 .man {
        width:25.8vw;
    }
    .person4 .name {
    }
    .mountains {
        width:100%;
        position:absolute;
        left:0;
    }
    .mountains .mountain2 {
        position:absolute;
        width:100vw;
        height:161vw;
        left:0;
    }
    .icon2 {
        position:absolute;
        width:55.46vw;
        bottom:0;
        left:10vw;
    }
    .endcontent {
        position:relative;
        width:73.6vw;
        height:156.8vw;
        margin:0 auto;
        background-size:100% 100%;
        overflow:hidden;
    }
    .endcontent img {
        display:block;
        width:44.1vw;
        margin:35vw auto 2vw;
    }
    .endcontent  .content {
        font-family: "simkai";
        color:#0e0906;
        font-size:4vw;
        padding:5vw 10vw;
        line-height:2;
        text-indent:2em;
    }
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue